export const imageCatalog = {
  zhaozhou: {
    cover: "/images/optimized/zhaozhou-opt.webp",
    gallery: ["/images/optimized/zhaozhou-opt.webp"],
  },
  lugou: {
    cover: "/images/optimized/lugou-opt.webp",
    gallery: ["/images/optimized/lugou-opt.webp"],
  },
  luoyang: {
    cover: "/images/optimized/luoyang-opt.webp",
    gallery: ["/images/optimized/luoyang-opt.webp"],
  },
  baodai: {
    cover: "/images/optimized/baodai-opt.webp",
    gallery: ["/images/optimized/baodai-opt.webp"],
  },
  guangji: {
    cover: "/images/optimized/guangji-opt.webp",
    gallery: ["/images/optimized/guangji-opt.webp"],
  },
  bianhe: {
    cover: "/images/optimized/bianhe-opt.webp",
    gallery: ["/images/optimized/bianhe-opt.webp"],
  },
  shuangqiao: {
    cover: "/images/optimized/shuangqiao-opt.webp",
    gallery: [
      "/images/optimized/shuangqiao-opt.webp",
      "/images/optimized/shuangqiao_1-opt.webp",
      "/images/optimized/shuangqiao_2-opt.webp",
      "/images/optimized/shuangqiao_3-opt.webp",
    ],
  },
  yongtong: {
    cover: "/images/optimized/yongtong-opt.webp",
    gallery: ["/images/optimized/yongtong-opt.webp"],
  },
  wanan: {
    cover: "/images/optimized/wanan-opt.webp",
    gallery: ["/images/optimized/wanan-opt.webp"],
  },
  tongji: {
    cover: "/images/optimized/tongji-opt.webp",
    gallery: ["/images/optimized/tongji-opt.webp"],
  },
  anping: {
    cover: "/images/optimized/anping-opt.webp",
    gallery: ["/images/optimized/anping-opt.webp"],
  },
  shunji: {
    cover: "/images/optimized/shunji-opt.webp",
    gallery: ["/images/optimized/shunji-opt.webp"],
  },
  jinshui: {
    cover: "/images/optimized/jinshui-opt.webp",
    gallery: ["/images/optimized/jinshui-opt.webp"],
  },
  taiping: {
    cover: "/images/optimized/taiping-opt.webp",
    gallery: ["/images/optimized/taiping-opt.webp"],
  },
  yudai: {
    cover: "/images/optimized/yudai-opt.webp",
    gallery: ["/images/optimized/yudai-opt.webp"],
  },
  ninedragon: {
    cover: "/images/optimized/ninedragon-opt.webp",
    gallery: ["/images/optimized/ninedragon-opt.webp"],
  },
  fengyu: {
    cover: "/images/optimized/fengyu-opt.webp",
    gallery: ["/images/optimized/fengyu-opt.webp"],
  },
};
